import React from "react";
import styled from "@emotion/styled";

const Checkbox = ({
  label,
  checked = false,
  onChange,
  name,
  required = false,
  disabled = false,
  className,
}) => {
  return (
    <CheckboxWrapper className={className}>
      <CheckboxInput
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange?.(e.target.checked)}
        name={name}
        disabled={disabled}
        required={required}
      />
      <CustomCheckbox>
        {checked ? (
          <CheckIcon>
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.6667 3.5L5.25 9.91667L2.33333 7"
                stroke="rgb(97, 98, 197)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </CheckIcon>
        ) : null}
      </CustomCheckbox>
      {label && <Label disabled={disabled}>{label}</Label>}
    </CheckboxWrapper>
  );
};

const CheckboxWrapper = styled.label`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 0px;
  cursor: pointer;
  user-select: none;
`;

const CheckboxInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

const CustomCheckbox = styled.div`
  width: 24px;
  height: 24px;
  border: 1px solid rgb(224, 228, 244);
  border-radius: 6px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;

  ${CheckboxInput}:checked + & {
    background: rgb(97, 98, 197);
    border-color: rgb(97, 98, 197);
  }

  ${CheckboxInput}:focus + & {
    box-shadow: 0 0 0 2px rgba(97, 98, 197, 0.2);
  }

  ${CheckboxInput}:disabled + & {
    background: rgb(241, 245, 249);
    border-color: rgb(224, 228, 244);
    cursor: not-allowed;
  }

  &:hover {
    border-color: rgb(97, 98, 197);
  }
`;

const CheckIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  color: white;
`;

const Label = styled.span`
  color: ${(props) =>
    props.disabled ? "rgb(148, 163, 184)" : "rgb(33, 37, 67)"};
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  flex: 1;
`;

export default Checkbox;
